<!-- First page that unauthenticated users see in the app wrappers. -->

<template>
  <v-layout
    column
    fill-height
  >
    <img
      :src="logoUrl"
      width="100%"
      height="auto"
      style="max-width: 300px; max-height: 56px"
    >
    <v-spacer />
    <v-layout column>
      <v-card
        flat
        color="transparent"
      >
        <v-card-text
          class="msr--text pt-0 pb-1 ci-font--bold"
          :class="{
            'landing-title': $vuetify.breakpoint.height >= 667,
            'landing-title--narrow': $vuetify.breakpoint.height < 667,
          }"
        >
          ALL
          <br>YOU <br>NEED <br>
          <span class="stroked-outline">IN STORE.</span>
          <br>
        </v-card-text>
      </v-card>
      <v-card
        flat
        class="ci-font--regular"
        color="transparent"
      >
        <v-card-text class="white--text landing-header pt-0 pb-1">
          {{ $t('landingHeader') }}
        </v-card-text>
      </v-card>
      <v-spacer />
      <v-btn
        class="mt-3 primary-btn msr no-border ci-font--bold"
        round
        large
        :block="$vuetify.breakpoint.xs"
        :to="{name: 'signup'}"
      >
        <span class="white--text">{{ $t('landingButtonSignup') }}</span>
      </v-btn>
      <v-spacer />
      <div class="white--text my-2">
        <v-layout
          column
          justify-center
          align-center
        >
          <!-- Login Link -->
          <span
            style="font-size: 2.5vh"
            class="ci-font--regular"
          >{{
            $t('landingAlreadyHaveAccount') + '?'
          }}</span>
          <v-btn
            class="secondary-btn transparent msr-border my-1"
            round
            large
            :block="$vuetify.breakpoint.xs"
            :to="{name: 'login'}"
          >
            <span class="white--text ci-font--bold">{{
              $t('landingToLogin')
            }}</span>
          </v-btn>
          <!-- Wifi Commissioning Link (mobile webview only) -->
          <v-btn
            v-if="wifiCommissioningAvailable"
            class="secondary-btn transparent msr-border my-1"
            round
            large
            :block="$vuetify.breakpoint.xs"
            @click="goToWifiCommissioning()"
          >
            <span class="white--text ci-font--bold">{{
              $t('landingWifiCommissioningButton')
            }}</span>
          </v-btn>
        </v-layout>
      </div>
      <v-spacer />
    </v-layout>
  </v-layout>
</template>

<script>
import {goToWifiCommissioning} from '@/mixins/wifiCommissioning';

export default {
  computed: {
    wifiCommissioningAvailable() {
      return (
        this.$store.state.common.isUsingWebview &&
        window.MYSHOPRADIO_APP_WRAPPER !== undefined &&
        window.MYSHOPRADIO_APP_WRAPPER.startWifiCommissioning !== undefined
      );
    },
    logoUrl() {
      return '/static/logo_myshopradio_tv_white.svg';
    },
  },
  methods: {
    goToWifiCommissioning() {
      const vm = this;
      goToWifiCommissioning(vm);
    },
  },
};
</script>

<style scoped>
@font-face {
  font-family: TTNormsRegular;
  src: url('https://cms.myshopradio.de/filer/canonical/1653379905/886/');
}

@font-face {
  font-family: TTNormsBold;
  src: url('https://cms.myshopradio.de/filer/canonical/1653379905/887/');
}

.ci-font--regular {
  line-height: 1.4;
  font-family: TTNormsRegular;
}

.ci-font--bold {
  line-height: 1.4;
  font-family: TTNormsBold;
}

.secondary-btn,
.primary-btn {
  font-size: 2.5vh !important;
  border: 1px solid white;
  box-shadow: none !important;
}

.secondary-btn {
  max-height: 36px;
  min-height: 36px; /* fallback */
}
.secondary-btn >>> .v-btn__content {
  height: 36px;
}

.no-border {
  border: none !important;
}

.msr-border {
  border: 2px solid var(--msr-color-primary) !important;
}

.primary-btn {
  max-height: 40px;
  min-height: 40px; /* fallback */
  min-height: 7vh;
}

.link {
  text-decoration: underline;
}

.landing-title {
  text-transform: uppercase;
  font-size: 3.8rem;
  line-height: 4.4rem;
}
.landing-title--narrow {
  text-transform: uppercase;
  font-size: 2.8rem;
  line-height: 3.6rem;
}

.stroked-outline {
  -webkit-text-fill-color: transparent;
  -webkit-text-stroke: 1px;
}

.landing-header {
  text-transform: uppercase;
  font-size: 18px !important; /* fallback */
  font-size: 5vw !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/Landing.vue